<template>
  <div class="">
    <div class="row">
      <div class="col-12 col-md-5">
        <documents-send-mail-form
          :documentData="salesDelivery"
          :dispatchUrl="'salesDeliveries/sendMail'"
          :toggleMailModal="toggleMailModal"
          :mailInformation="mailInformation"
        />
      </div>
      <div
        class="col-12 col-md-7"
        style="max-height: 550px; overflow-y: scroll"
      >
        <sales-delivery-view-details
          :showHeader="false"
          :salesDelivery="salesDelivery"
          @salesDeliveryItemsUpdated="get"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <el-button type="danger" @click="toggleMailModal">
        {{ $t("COMMON.CANCEL") }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import "flatpickr/dist/flatpickr.css";
import formMixin from "@/mixins/form-mixin";
import DocumentsSendMailForm from "@/components/DocumentsSendMailForm";
import SalesDeliveryViewDetails from "./SalesDeliveryViewDetails";

export default {
  layout: "DashboardLayout",
  name: "sales-delivery-mail-modal-content",

  components: {
    DocumentsSendMailForm,
    SalesDeliveryViewDetails,
    [Button.name]: Button,
  },

  mixins: [formMixin],
  props: {
    salesDelivery: {
      default: () => {},
    },
    toggleMailModal: {
      type: Function,
    },
    get: {
      type: Function,
    },
    loading: {
      default: () => true,
    },
  },

  data() {
    return {
      submitting: false,
      mailInformation: {
        organization: {},
        recipient: {},
        user: {},
      },
    };
  },

  created() {},

  mounted() {
    /*
    this.mailInformation = {
      organization: this.salesDelivery.organization,
      subject: this.$t('COMMON.EMAIL_INFOS_SUBJECT_DELIVERY', {
        organization: this.salesDelivery.organization?.name,
        code: this.salesDelivery.code,
      }),
      recipient: {
        username: this.salesDelivery?.recipient?.customer_name,
        email: this.salesDelivery?.recipient?.email,
      },
    }
     */
  },

  methods: {},

  watch: {
    /*salesDelivery(salesDelivery) {
      this.mailInformation = {
        organization: salesDelivery.organization,
        subject: this.$t('COMMON.EMAIL_INFOS_SUBJECT_DELIVERY', {
          organization: salesDelivery.organization?.name,
          code: salesDelivery.code,
        }),
        recipient: {
          username: salesDelivery?.recipient?.customer_name,
          email: salesDelivery?.recipient?.email,
        },
      }
    }*/
  },
};
</script>
